/** AI generation API client (web) — /api/v1/ai-generation. apiClient throws
 * ApiError on non-2xx (403 = plan-gated, 429 = quota, 409 = already saved);
 * callers map status → message. */
import { apiClient } from '../../../services/apiClient';
import type {
  AiGenerationJobDto,
  CreateAiGenerationRequest,
  QuotaStatusDto,
  SavedClipDto,
  SuggestionsResponse,
  VoicesResponse,
} from '../types';

const BASE = '/api/v1/ai-generation';

export const submitGeneration = (request: CreateAiGenerationRequest) =>
  apiClient.post<AiGenerationJobDto>(BASE, request);

export const pollGenerationStatus = (jobId: string) =>
  apiClient.get<AiGenerationJobDto>(`${BASE}/${jobId}`);

export const saveGeneratedClip = (jobId: string) =>
  apiClient.post<SavedClipDto>(`${BASE}/${jobId}/save`);

export const discardGeneration = (jobId: string) =>
  apiClient.post<void>(`${BASE}/${jobId}/discard`);

export const getVoices = (language?: string) =>
  apiClient.get<VoicesResponse>(
    `${BASE}/voices${language ? `?language=${encodeURIComponent(language)}` : ''}`,
  );

export const getSuggestions = (clipType: string, language: string) =>
  apiClient.get<SuggestionsResponse>(
    `${BASE}/suggestions?clipType=${encodeURIComponent(clipType)}&language=${encodeURIComponent(language)}`,
  );

export const getQuota = () => apiClient.get<QuotaStatusDto>(`${BASE}/quota`);
